import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type OpenedCardState = {
  value: ShipmentModel | null;
};

const initialOpenedCardState: OpenedCardState = {
  value: null,
};

const openedCardSlice = createSlice({
  name: "openedCard",
  initialState: initialOpenedCardState,
  reducers: {
    setOpenedCardAction: (state, action: PayloadAction<ShipmentModel | null>) => {
      state.value = action.payload;
    },
    updateOpenCardAction: (state, action: PayloadAction<ShipmentModel>) => {
      state.value = action.payload;
    },
  },
});

const openedCardBaseSelector = createBaseSelector(openedCardSlice);

registerSlice([openedCardSlice]);

export const openedCardStore = {
  actions: openedCardSlice.actions,
  selectors: {
    openedCard: createSelector(openedCardBaseSelector, (s) => s.value),
  },
};
